import { useEffect, useState } from 'react';
import { CordeliaLogoSvgPSP, HamburgerIconSvgPSP, PercentIconSvgPSP } from '../../svgImages';
import './style.scss';

const NavBarPSP: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);
  
  useEffect(() => {
    if (open) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }, [open]);
  
  return (
    <div className="navbar-parent-wrapper-psp">
      <div className="navbar-content-wrapper-psp">
        <a href="https://www.cordeliacruises.com/"><CordeliaLogoSvgPSP /></a>
        <div className="navbar-routes-wrapper-psp disappear">
          <a href="https://www.cordeliacruises.com/promotion"><PercentIconSvgPSP />Offers</a>
          <a href='https://www.cordeliacruises.com/destination'>Destinations</a>
          <a href='https://www.cordeliacruises.com/?contact'>Contact</a>
          <a href='https://www.cordeliacruises.com/web-check-in/booking-details'>Web Check-in</a>
        </div>
        <div className='navbar-buttons-wrapper-psp disappear'>
          <a href="https://www.cordeliacruises.com/weekend" className='disappear'><button>Weekend Getaway</button></a>
          <a href="https://www.cordeliacruises.com/upcoming-cruises" className='disappear'><button>Find a Cruise</button></a>
          <span className='disappear' onClick={() => setOpen((prev: boolean) => !prev)}><HamburgerIconSvgPSP/></span>
        </div>
      </div>
      <div className={`navbar-slider-overlay ${open ? 'open' : ''}`} onClick={() => setOpen((prev: boolean) => !prev)}></div>
      <div className={`navbar-slider ${open ? 'navbar-slider-open' : 'navbar-slider-close'}`}>
        <div className="navbar-routes-wrapper-psp disappear">
            <a href="https://www.cordeliacruises.com/promotion"><PercentIconSvgPSP />Offers</a>
            <a href='https://www.cordeliacruises.com/destination'>Destinations</a>
            <a href='https://www.cordeliacruises.com/?contact'>Contact</a>
            <a href='https://www.cordeliacruises.com/web-check-in/booking-details'>Web Check-in</a>
          </div>
        <div className='navbar-buttons-wrapper-psp disappear'>
            <a href="https://www.cordeliacruises.com/weekend" className='disappear'><button>Weekend Getaway</button></a>
            <a href="https://www.cordeliacruises.com/upcoming-cruises" className='disappear'><button>Find a Cruise</button></a>
        </div>
      </div>
    </div>
  );
}

export default NavBarPSP;